/**
 * KAN-829/KAN-830: бот для менеджеров (один Telegram-бот платформы для уведомлений менеджерам).
 * Организации бота не подключают, статус только читается.
 *
 *   GET    /api/v1/organization/manager-bot/          - {connected, bot_username}
 *   POST   /api/v1/managers/{id}/telegram-link/       - {url, expires_at}: ссылка привязки менеджера
 *   DELETE /api/v1/managers/{id}/telegram/            - отвязать Telegram менеджера
 */
import apiClient from './client';

/** Статус бота для менеджеров (бот платформы). */
export interface ManagerBotStatus {
  connected: boolean;
  /** null или пусто: бот не подключён (или имя ещё не получено). */
  bot_username: string | null;
}

/** Ссылка привязки Telegram менеджера (действует 24 часа). */
export interface ManagerTelegramLink {
  url: string;
  expires_at: string;
}

const BOT_URL = '/api/v1/organization/manager-bot/';

export const managerBotApi = {
  async getStatus(): Promise<ManagerBotStatus> {
    const res = await apiClient.get<ManagerBotStatus>(BOT_URL);
    return res.data;
  },

  async createManagerLink(managerId: string): Promise<ManagerTelegramLink> {
    const res = await apiClient.post<ManagerTelegramLink>(`/api/v1/managers/${managerId}/telegram-link/`);
    return res.data;
  },

  async unlinkManager(managerId: string): Promise<void> {
    await apiClient.delete(`/api/v1/managers/${managerId}/telegram/`);
  },
};
